import React, { Component } from 'react';
import InfoPopup from '../../Dashboard/Common/accountDetailsInfopopup';
import FocusTrap from "focus-trap-react";
import QRCode from 'react-qr-code';
import classes from './accountDetailsPopup.scss';
import CustomStatusFlag from '../../Common/CommonComponents/StatusTab/statusTab';
export default class AccountDetailsPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rotatingOutageGrpId: app.appService.getSessionstorage('rotatingOutageGrpId') ? app.appService.getSessionstorage('rotatingOutageGrpId')[this.props.contractNumber]: '',
            rinValue: app.appService.getSessionstorage('rinValue') ? app.appService.getSessionstorage('rinValue')[this.props.contractNumber] : '',
            isDataLoading: true,
            isROGDataError: false,
            isRINDataError: false,
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.fetchRatePlan= this.fetchRatePlan.bind(this);
        this.viewMyAcountDetails= this.viewMyAcountDetails.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
        this.viewMyAcountDetails(this.props.contractAccountNumber, this.props.contractNumber);
        this.fetchRatePlan(this.props.contractNumber);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    componentDidUpdate() {
        document.addEventListener('click', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        (this.wrapperRef && !this.wrapperRef.contains(event.target)) && this.props.openClosePopup('close');
    }

    viewMyAcountDetails = (cact, contractNumber) => {
        if (!app.appService.getSessionstorage('rotatingOutageGrpId') || !app.appService.getSessionstorage('rotatingOutageGrpId')[contractNumber]) {
            app.appService.removeSessionStorageItem('rotatingOutageGrpId');
            app.dashboardService.getROGroupId(cact, contractNumber).then(
                (response) => {
                    if(!response.errorCode){
                        app.appService.setSessionstorage('rotatingOutageGrpId', { [contractNumber]: response.rotatingOutageGrpId });
                        app.appService.setSessionstorage('mailingAddress', response.mailingAddress);
                        this.setState({ rotatingOutageGrpId: response.rotatingOutageGrpId, mailingAddress: response.mailingAddress });
                    }
                    else{
                        this.setState({isROGDataError: true});
                    }
                }, (error) => { this.setState({isROGDataError:true});}
            );
        }
    };
    fetchRatePlan = (contractNumber) => {
            if (!app.appService.getSessionstorage('rinValue') || !app.appService.getSessionstorage('rinValue')[contractNumber]) {
                app.appService.removeSessionStorageItem('rinValue');
                app.dashboardService.getRatePlan(contractNumber).then(
                    (response) => {
                        if(!response.errorCode){
                            app.appService.setSessionstorage('rinValue', { [contractNumber]: response.rin });
                            this.setState({ rinValue: response.rin, isDataloading:false });}
                        else{
                            this.setState({ isDataloading:false, isRINDataError: true});
                        }
                    }, (error) => {
                        this.setState({ isDataloading:false, isRINDataError: true});
                     }
                );
            }
        }  
        

    render(){
        const contractStartDate = app.appUtil.formatDate((this.props.contractStartDate), 'MMMM DD, YYYY');
        const contractEndDate = app.appUtil.formatDate((this.props.contractEndDate), 'MMMM DD, YYYY');
        const headingPod = <span className={classes.scePopupLabel}> POD ID </span>;
        const headingROG = <span className={classes.scePopupLabel}> Rotating Outage Group </span>;
        const headingRIN = <span className={classes.scePopupLabel}> Rate Identification Number -<br className={classes.scePopupTablet} /> RIN </span>;
        // const firstName = this.props.firstName;
        // const lastName = this.props.lastName;
        const displayName = this.props.customerAccountName;
        // const loginName = displayName.split(',').map(part => part.trim());

        const serviceAccountStatusCode = this.props.serviceAccountStatusCode === 'I' ?
            <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetailSec}>
                <p className={classes.scePopupLabel}>Move-out Date</p>
                <p className={classes.scePopupdisplayData}>{contractEndDate}</p>
            </div> : null;

        const rogSection = this.state.rotatingOutageGrpId && this.state.rotatingOutageGrpId!=="" ?        
        <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetailSec}>
            <InfoPopup heading={headingROG} content='ROG' />
            <p className={classes.scePopupdisplayData}>{this.state.rotatingOutageGrpId}</p>
        </div> : null;
        return (
            <div className={classes.scePopupOverlay}>
                <div className={classes.scePopupOverlayContent}>
                    <FocusTrap>
                        <div tabIndex="0" ref={this.setWrapperRef} className={classes.scePopupBox}>
                            <div className={classes.scePopUpTitleArea}>
                                <span><button className={classes.scePopupiconClose} onClick={() => this.props.openClosePopup('close')}><img src={this.closeIcon} alt="Close Icon" /></button></span>
                                <div className={classes.scePopupHeader}>Service Account Details</div>
                            </div>
                            <div className={classes.scePopupGreyAddressBox}>
                                <h1 data-pii-encrypt className={classes.scePopupGreyBoxAddressLine}>{this.props.serviceStreetAddress}</h1>
                            </div>
                            <div className={classes.scePopupContentArea}>
                                <div id="infoPopupContent" className={classes.scePopupContent}>
                                <div>
                                        <div className={'row ' + classes.scePopupDetail + ' '}>
                                                <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetailSec}>
                                                    <p className={classes.scePopupLabel}>Service Account</p>
                                                    <p data-pii-encrypt className={classes.scePopupdisplayData}>{this.props.contractNumber}</p>
                                                </div>
                                                <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetailSec}>
                                                    <p className={classes.scePopupLabel}>Account Status</p>
                                                    <CustomStatusFlag serviceAccountStatusCode={this.props.serviceAccountStatusCode} />
                                                </div>
                                                <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetailSec}>
                                                    <p className={classes.scePopupLabel}>Rate Plan</p>
                                                    <p className={classes.scePopupdisplayData}>{this.props.currentServicePlan}</p>
                                                </div>
                                                <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetailSec}>
                                                    <p className={classes.scePopupLabel}>Move-in Date</p>
                                                    <p className={classes.scePopupdisplayData}>{contractStartDate}</p>
                                                </div>
                                                <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetailSec}>
                                                    <InfoPopup heading={headingPod} content='PODID' />
                                                    <p data-pii-encrypt className={classes.scePopupdisplayData}>{this.props.podId}</p>
                                                </div>
                                                {rogSection}
                                                {this.props.currentServicePlan.includes("TOU" || "AL-2") ?
                                                this.state.rinValue ?
                                                <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetailSec}>
                                                    <div className={classes.sceRinHeader}>
                                                        <InfoPopup heading={headingRIN} content='RIN' />
                                                        <div className={classes.sceQrCode} >
                                                            <div className={classes.sceRin}>
                                                                <p className={classes.sceRinValue}>{this.state.rinValue}</p>                                                                     
                                                            </div>
                                                            <div className={classes.sceQr}>
                                                                <QRCode
                                                                    size={256}
                                                                    style={{ height: "auto", maxWidth: "100%" }}
                                                                    value={String(this.state.rinValue)}
                                                                    viewBox={`0 0 25 256`}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                            {this.state.isDataLoading ? null : <div className={classes.sceRinDisclaimerMsg}>Currently RIN details are not available.</div>}</div>
                                                    : null: null}
                                                {serviceAccountStatusCode}
                                        </div>
                                        <hr />
                                        <div className={'row ' + classes.sceModalRow + ' '}>
                                            <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetail + ' '}>
                                                <div className={classes.scePopupDetailSec}>
                                                    <p className={classes.scePopupLabel}>Customer Name</p>
                                                    <p data-pii-encrypt className={classes.scePopupdisplayData}>{displayName}</p>
                                                </div>
                                                <div className={classes.scePopupDetailSec}>
                                                    <p className={classes.scePopupLabel}>Mailing Address</p>
                                                    <p data-pii-encrypt className={classes.scePopupdisplayData}>{this.props.mailingAddress}</p>
                                                </div>
                                            </div>
                                            <div className={'col-sm-6 col-xs-12 ' + classes.scePopupDetail + ' '}>
                                                <div className={classes.scePopupDetailSec}>
                                                    <p className={classes.scePopupLabel}>Customer Account</p>
                                                    <p data-pii-encrypt id='sce_myAccDetailsPopup_cactNum' className={classes.scePopupdisplayData}>{this.props.contractAccountNumber}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FocusTrap>
                </div>
            </div>
        );
    }
}